export default __webpack_public_path__ + "static/media/PPI-patio-032.1e36f3af.jpg";